<!--
 * @Author: your name
 * @Date: 2021-08-20 11:27:45
 * @LastEditTime: 2023-04-26 12:02:59
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Description: In User Settings Edit
 * @FilePath: \鲁南\src\modules\fire\components\controlTop.vue
-->
<template>
  <div class="control-alarmlist" :class="{ 'control-list-show': isShow }">
    <div class="control-list-panel flex-valign">
      <div class="list-search flex-between valign-center map-blur-panel__title">
        <div
          class="text-center flex-auto rel pointer"
          style="
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            padding-right: 15px;
          "
        >
          <!-- 主机名称收索 -->
          <div
            @click.stop="
              nameExpandType = !nameExpandType;
              typeExpandType = false;
              searchText = '';
            "
            class="valign-center"
          >
            <div class="mr5 ell" style="margin-left: 10px">
              <span>{{ subsystemText }}</span>
            </div>
            <span
              :class="[
                'iconfont-lunan icon-lunan-xiaosanjiaodown',
                nameExpandType ? 'icon-transform' : '',
                'select-arrow',
              ]"
            ></span>
          </div>
          <!-- 部件类型 -->
          <div
            @click.stop="
              nameExpandType = false;
              typeExpandType = !typeExpandType;
              searchText = '';
            "
            class="valign-center"
          >
            <div class="mr5 ell" style="margin-left: 10px">
              <span>部件类型 </span>
            </div>
            <span
              :class="[
                'iconfont-lunan icon-lunan-xiaosanjiaodown',
                typeExpandType ? 'icon-transform' : '',
                'select-arrow',
              ]"
            ></span>
          </div>
          <!-- 配置控制切换 -->
          <div class="valign-center">
            <div class="mr5 ell" style="margin-left: 10px">
              <el-switch
                v-model="controlType"
                @change="handleTypeChange"
                active-color="#3E76E6"
                active-text="配置"
                inactive-text="控制"
              >
              </el-switch>
            </div>
          </div>
          <div :class="['type-select', nameExpandType || typeExpandType ? 'expand' : '']">
            <el-scrollbar class="select-area flex-valign">
              <el-input
                style="width: 95%"
                placeholder="请输入搜索关键字"
                prefix-icon="el-icon-search"
                v-model="searchText"
                @click.stop.native="stopPropagation"
                clearable
              >
              </el-input>
              <el-cascader-panel
                v-if="nameExpandType"
                v-model="searchForm.name"
                ref="cascaderPanel"
                :options="restaurants"
                @change="cascaderChangeS"
                :props="cascaderProps2"
              ></el-cascader-panel>

              <el-cascader-panel
                v-if="typeExpandType"
                v-model="searchForm.type"
                ref="cascaderPanel2"
                :options="subDeviceMark"
                @change="cascaderChange"
              ></el-cascader-panel>
            </el-scrollbar>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Dic } from "$utils";
import { api } from "../api";
export default {
  name: "control-Top",
  components: {},
  props: {},
  data() {
    return {
      isShow: true,
      searchForm: {
        name: "",
        type: "",
      },
      typeExpandType: false,
      nameExpandType: false,
      cascaderProps2: {
        children: "children",
        label: "value",
        value: "value",
        expandTrigger: "hover",
      },
      subsystemText: "主机名称",
      nameArr: {},
      restaurants: [],
      bfRestaurants: [],
      searchText: "",
      controlType: false,
      subDeviceMark: [
        {
          label: "全部",
          value: "",
          item: {},
        },
      ],
      bfsubDeviceMark: [
        {
          label: "全部",
          value: "",
          item: {},
        },
      ],
    };
  },
  watch: {
    searchText(value) {
      if (this.nameExpandType) {
        console.log(this.restaurants);
        if (value) {
          let filterList = this.restaurants.filter((el) => {
            if (el.value.indexOf(value) !== -1) {
              return el;
            }
          });
          this.restaurants = [...filterList];
        } else {
          this.restaurants = [...this.bfRestaurants];
        }
      } else {
        if (value) {
          let filterList = this.subDeviceMark.filter((el) => {
            if (el.label.indexOf(value) !== -1) {
              return el;
            }
          });
          this.subDeviceMark = [...filterList];
        } else {
          this.subDeviceMark = [...this.bfsubDeviceMark];
        }
      }
    },
  },
  created() {
    this.nameArr = {};
    for (var i = 65; i < 91; i++) {
      this.nameArr[String.fromCharCode(i) + "区"] = [];
    }
    Dic.find("SENU094").map((el) => {
      if (el.value != 0 && el.value <= 99) {
        el.label = el.label + "【海湾】";
      } else if (el.value != 0 && el.value > 99) {
        el.label = el.label + "【北大青鸟】";
      }
      this.subDeviceMark.push(el);
      this.bfsubDeviceMark.push(el);
    });
  },
  mounted() {
    this.queryFireDevice();
    document.addEventListener("click", this.domClick);
  },

  beforeDestroy() {
    document.removeEventListener("click", this.domClick);
  },
  methods: {
    // 配置或者控制页面类型 true:配置，false:控制
    handleTypeChange(val) {
      this.$emit("handleType", val);
    },
    queryFireDevice() {
      this.$fetch(api.cms.queryFireDevice, {
        deviceMarkList: ["27", "28", "29"],
        pageNum: 1,
        pageSize: 10000,
        systemId: "200000024",
      }).then((response) => {
        if (response.success) {
          // 设备名称
          // this.restaurants = [
          //   {
          //     label: "全部",
          //     item: {},
          //     id: "",
          //   },
          // ].concat(
          //   response.returnObj.list.map((el) => {
          //     return {
          //       label: el.thirdDeviceName  + ' ( ' + el.thirdDeviceId + ' )',
          //       id: el.thirdDeviceId,
          //       item: el,
          //       deviceID: el.deviceID,
          //     };
          //   })
          // );
          // this.bfRestaurants = [...this.restaurants];
          let newArr = [];
          let otherArr = [];
          response.returnObj.list.forEach((el, index) => {
            newArr.push({
              value: el.thirdDeviceName ,//+ " ( " + el.thirdDeviceId + " )",
              id: el.thirdDeviceId,
            });
            // let nameId = el.thirdDeviceName.slice(0, 2);
            // if (this.nameArr[nameId]) {
            //   this.nameArr[nameId].push({
            //     value: el.thirdDeviceName, //+ ' ( ' + el.thirdDeviceId + ' )'
            //     id: el.thirdDeviceId,
            //     deviceID: el.deviceID,
            //   });
            //   // newArr.push()
            // } else {
            //   otherArr.push({
            //     value: el.thirdDeviceName + " ( " + el.thirdDeviceId + " )",
            //     id: el.thirdDeviceId,
            //     deviceID: el.deviceID,
            //   });
            // }
          });

          // console.log(this.nameArr)
          // for (let key in this.nameArr) {
          //   if (this.nameArr[key].length > 0) {
          //     newArr.push({
          //       value: key,
          //       label: key,
          //       children: this.nameArr[key],
          //     });
          //   }
          // }
          // otherArr.push({
          //   value: "电气火灾",
          //   id: '-1'
          // })
          // newArr.push({
          //   value: "其他",
          //   label: "其他",
          //   children: otherArr,
          // });
          this.restaurants = JSON.parse(JSON.stringify(newArr));
          this.bfRestaurants = [...this.restaurants];
        } else {
          // this.$message.error(response.msgContent || "获取设备详情失败");
        }
      });
    },
    cascaderChange(value) {
      let params = {};
      params.parentThirdDeviceId = this.searchForm.name[1] && this.searchForm.name[1];
      params.subDeviceMark = this.searchForm.type[0] && this.searchForm.type[0];
      this.$emit("handleSearch", params);
    },
    cascaderChangeS(value) {
      let params = {};
      params.parentThirdDeviceId = this.searchForm.name[0] && this.searchForm.name[0];
      params.subDeviceMark = this.searchForm.type[0] && this.searchForm.type[0];
      this.$emit("handleSearch", params);
    },
    stopPropagation() {
      // 阻止冒泡
    },
    domClick() {
      this.typeExpandType = false;
      this.nameExpandType = false;
    },
  },
};
</script>
<style lang="scss">
.el-switch__label {
  color: #fff;
}
.el-switch__label.is-active {
  color: #3e76e6;
}
@import "../style/control-left.scss";
.type-select {
  .el-cascader-menu {
    width: 100%;
  }
}
</style>
